import React from "react";
import "./RadioCardGroup.scss";

interface RadioCardOption<T> {
  label: string;
  description?: string;
  value: T;
}

interface RadioCardGroupProps<T> {
  name: string;
  options: RadioCardOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

function RadioCardGroup<T>({
  name,
  options,
  value,
  onChange,
}: RadioCardGroupProps<T>) {
  return (
    <div className="radio-card-group" role="radiogroup">
      {options.map((option, index) => {
        const selected = value === option.value;
        return (
          <label
            key={index}
            className={`radio-card${selected ? " radio-card--selected" : ""}`}
          >
            <input
              type="radio"
              name={name}
              checked={selected}
              onChange={() => onChange(option.value)}
              className="radio-card__input"
            />
            <span className="radio-card__indicator" />
            <span className="radio-card__content">
              <span className="radio-card__label">{option.label}</span>
              {option.description && (
                <span className="radio-card__description">
                  {option.description}
                </span>
              )}
            </span>
          </label>
        );
      })}
    </div>
  );
}

export default RadioCardGroup;
